import type { Fragment } from '../translations';

export const tickets: Fragment = {
  fr: {
    'tk.new': 'Signaler un problème',
    'tk.filter.toTriage': 'À trier',
    'tk.filter.inProgress': 'En cours',
    'tk.filter.mine': 'Les miens',
    'tk.filter.resolved': 'Résolus',
    'tk.process': 'Processus concerné',
    'tk.where': 'Où dans le processus ?',
    'tk.whereHint': 'Optionnel — une étape ou un couloir du diagramme',
    'tk.what': 'Que s\'est-il passé ?',
    'tk.details': 'Détails',
    'tk.severity': 'Gravité',
    'tk.severity.low': 'Faible',
    'tk.severity.normal': 'Normale',
    'tk.severity.high': 'Élevée',
    'tk.status.open': 'Ouvert',
    'tk.status.triage': 'À trier',
    'tk.status.in_progress': 'En cours',
    'tk.status.resolved': 'Résolu',
    'tk.status.rejected': 'Rejeté',
    'tk.assignTo': 'Assigné à',
    'tk.resolve': 'Résoudre',
    'tk.resolution': 'Note de résolution (obligatoire)',
    'tk.openRework': 'Ouvrir une refonte',
    'tk.spawned': 'Refonte {code} ouverte le {date} — étape {n}',
    'tk.spawnedShort': 'Refonte {code} ouverte',
    'tk.grpCycle': 'Processus en cycle',
    'tk.grpDocumented': 'Processus documentés',
    'tk.by': 'par {name}',
    'tk.empty': 'Aucun ticket. Si un processus ne se passe pas comme il est décrit, signalez-le.',
    'tk.select': 'Sélectionnez un ticket.',
    'tk.unlinked': 'Processus non lié',
    'tk.comment': 'Commentaire…',
    'tk.elementAt': 'Au niveau de « {el} »',
  },
  en: {
    'tk.new': 'Report a problem',
    'tk.filter.toTriage': 'To triage',
    'tk.filter.inProgress': 'In progress',
    'tk.filter.mine': 'Mine',
    'tk.filter.resolved': 'Resolved',
    'tk.process': 'Process concerned',
    'tk.where': 'Where in the process?',
    'tk.whereHint': 'Optional — a step or lane of the diagram',
    'tk.what': 'What happened?',
    'tk.details': 'Details',
    'tk.severity': 'Severity',
    'tk.severity.low': 'Low',
    'tk.severity.normal': 'Normal',
    'tk.severity.high': 'High',
    'tk.status.open': 'Open',
    'tk.status.triage': 'To triage',
    'tk.status.in_progress': 'In progress',
    'tk.status.resolved': 'Resolved',
    'tk.status.rejected': 'Rejected',
    'tk.assignTo': 'Assigned to',
    'tk.resolve': 'Resolve',
    'tk.resolution': 'Resolution note (required)',
    'tk.openRework': 'Open a rework',
    'tk.spawned': 'Rework {code} opened on {date} — step {n}',
    'tk.spawnedShort': 'Rework {code} opened',
    'tk.grpCycle': 'Processes in cycle',
    'tk.grpDocumented': 'Documented processes',
    'tk.by': 'by {name}',
    'tk.empty': 'No tickets. If a process does not go as described, report it.',
    'tk.select': 'Select a ticket.',
    'tk.unlinked': 'Process not linked',
    'tk.comment': 'Comment…',
    'tk.elementAt': 'At "{el}"',
  },
};
